import React, { useState } from 'react';

import './login.scss';

import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useSpring, animated as a } from 'react-spring';

import { LoginFormValuesType } from 'src/app/pages/LoginPage/login-page.config';
import { enumHelper, routeHelper, storageHelper } from 'src/app/helpers';
import { formLocals } from 'src/locals';
import { reduxRootTypes, reduxUserTypes } from 'src/types';
import { userActions } from 'src/app/redux/actions';
import { userService } from 'src/app/services';

import styles from 'src/app/pages/LoginPage/LoginPage.module.scss';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { axios } from 'src/app/utils';
import { displayGenericError } from 'src/app/helpers/status.helper';

import { useTranslation } from 'react-i18next';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button/button';

const LoginPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const history = useHistory();

  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  const [showForm, setShowForm] = useState(false);

  const handleOnFinish = async (loginFormValues: LoginFormValuesType) => {
    try {
      const response = await userService.login(loginFormValues, {
        blockErrorHandler: true,
      });

      const { data } = response;

      if (response.data.user) {
        const convertedData: reduxUserTypes.UserLoginInformation = enumHelper.convertUserServiceToRedux(data?.user);
        dispatch(userActions.setInformation(convertedData));
        dispatch(userActions.setToken({ token: data.token, tokenc: data.hymotscToken }));

        axios.setToken(data.token);
        storageHelper.setValueWithKey('token', data.token);
        storageHelper.setValueWithKey('tokenc', data.hymotscToken);

        setTimeout(() => {
          routeHelper.handleRoute(history, '/');
        }, 500);
      }
    } catch (error: unknown) {
      displayGenericError(error);
    }
  };

  const onShowForm = () => {
    setShowForm(true);
  };

  setTimeout(() => {
    onShowForm();
  }, 1000);

  const logoProps = useSpring({
    from: { y: 80, opacity: 0.5 },
    to: { y: 0, opacity: 1 },
    config: {
      duration: 1000,
    },
  });

  const formProps = useSpring({
    opacity: showForm ? 1 : 0,
    transform: showForm ? 'translateY(0)' : 'translateY(40px)',
    config: {
      duration: 500,
    },
  });

  return (
    <>
      <div className={styles.logoContainer}>
        <a.img alt="logo" id="etecube-logo" className={styles.logo} style={logoProps} src="assets/etecube.png" />
      </div>
      <a.div style={{ ...formProps }} id="login-form">
        <Form layout="vertical" name="login" onFinish={handleOnFinish}>
          <Form.Item
            className="login-input-container"
            label="USERNAME"
            name={formLocals.formFields.login.userName}
            rules={[
              { required: true, message: t('errors.invalidUserName') || '' },
              { required: true, message: t('errors.fieldRequired') || '' },
            ]}
          >
            <Input
              size="large"
              prefix={<UserOutlined />}
              style={{
                backgroundColor: '#333333',
                padding: '10px',
              }}
            />
          </Form.Item>

          <Form.Item
            className="login-input-container"
            label="PASSWORD"
            name={formLocals.formFields.login.password}
            rules={[
              { required: true, message: t('errors.fieldRequired') || '' },
              // { min: 6, message: t("errors.min8") || "" },
              // { max: 64, message: t("errors.max64") || "" },
            ]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined />}
              style={{
                backgroundColor: '#333333',
                padding: '10px',
              }}
            />
          </Form.Item>

          {/* <Form.Item>
            <div className={styles.forgotPassword}>
              <Link className={styles.forgotPassword} to="/ForgotPassword">
                {loginTexts.register}
              </Link>
            </div>
          </Form.Item> */}

          <Form.Item>
            <Button
              style={{
                background: 'var(--ete-primary-green-color)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              block
              type="primary"
              htmlType="submit"
              className="login-submit-button"
            >
              LOGIN
            </Button>
          </Form.Item>
        </Form>
      </a.div>
    </>
  );
};

export default LoginPage;
